import { generateID } from "./common";

export const FormControlNames = {
  STEPCONTAINER: "step-container",
  INPUTTEXTFIELD: "text-field",
  // INPUTADDFIELD: "text-field",
  // INPUTNAMEFIELD: "text-field",
  // EMAILFIELD: "email",
  INPUTMULTILINE: "multiline-text-field",
  PHONEFIELD: "mobile-field",
  CHECKBOX: "checkbox",
  RADIOGROUP: "radio-group",
  SELECTDROPDOWN: "select-drop-down",
  DATEFIELD: "date-field",
  TIMEFIELD: "time-field",
  FILEUPLOAD: "file-upload",
  IMAGEUPLOAD: "image-upload",
  TOGGLE: "toggle",
  CHECKLIST: "checklist",
  // SIGNATURE: "signature",
  MULTICHOICES: "multi-choices",
  SCANCODE: "scan-code",
  VERIFIEDID: "verified-id",
  CAPTURECLICK: "capture-click",
  ATTACHUPLOAD: "attach-upload"

};

export const FormTextDataTypes = {
  TEXT: "text",
  NUMBER:"number"
};

export const FormItemTypes = {
  CONTROL: "control",
  CONTAINER: "container",
};

export const FormPublishStatus = {
  DRAFT: "draft",
  PUBLISHED: "published",
};

export const FormContainerList = [
  {
    id: "",
    controlName: FormControlNames.STEPCONTAINER,
    displayText: "Workflow Step",
    itemType: FormItemTypes.CONTAINER,
    icon: "fa fa-building",
    heading: "Container Heading",
    subHeading: "Container SubHeading",
  },
];

export const FormControlList = [
  {
    id: "",
    controlName: FormControlNames.INPUTTEXTFIELD,
    displayText: "Text Field",
    placeholder: "Placeholder for Text Field",
    description: "Some Description about the field",
    labelName: "Text Field",
    itemType: FormItemTypes.CONTROL,
    dataType: FormTextDataTypes.TEXT,
    icon: "fas fa-text-height",
    required: false,
    category: "text-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.PHONEFIELD,
    displayText: "Mobile No",
    placeholder: "Enter 10 digit Mobile No",
    description: "Some Description about the field",
    labelName: "Mobile No",
    itemType: FormItemTypes.CONTROL,
    dataType: FormTextDataTypes.NUMBER,
    icon: "fa fa-phone-volume",
    required: false,
    category: "text-elements",
    containerId: "",
  },
  // {
  //   id: "",
  //   controlName: FormControlNames.INPUTNAMEFIELD,
  //   displayText: "Name Fields",
  //   placeholder: "",
  //   description: "Please enter your first and last name",
  //   labelName: "Name",
  //   itemType: FormItemTypes.CONTROL,
  //   dataType: FormTextDataTypes.TEXT,
  //   icon: "fas fa-user",
  //   required: false,
  //   category: "text-elements",
  //   containerId: "",
  //   inputFields: [
  //     {
  //       id: "firstName",
  //       labelName: "First Name",
  //       placeholder: "Enter First Name",
  //       required: true,
  //     },
  //     {
  //       id: "lastName",
  //       labelName: "Last Name",
  //       placeholder: "Enter Last Name",
  //       required: true,
  //     },
  //   ],
  // },
  // {
  //   id: "",
  //   controlName: FormControlNames.INPUTADDFIELD,
  //   displayText: "Address Fields",
  //   placeholder: "",
  //   description: "Please enter your address",
  //   labelName: "Address",
  //   itemType: FormItemTypes.CONTROL,
  //   dataType: FormTextDataTypes.TEXT,
  //   icon: "fas fa-user",
  //   required: false,
  //   category: "text-elements",
  //   containerId: "",
  //   inputFields: [
  //     {
  //       id: "street address",
  //       labelName: "Street Address",
  //       placeholder: "Enter Street Address",
  //       required: true,
  //     },
  //     {
  //       id: "street address line 2",
  //       labelName: "Street Address Line 2",
  //       placeholder: "Enter Street Address Line 2",
  //       required: true,
  //     },
  //     {
  //       id: "city",
  //       labelName: "City",
  //       placeholder: "Enter city",
  //       required: true,
  //     },
  //     {
  //       id: "state",
  //       labelName: "State",
  //       placeholder: "Enter State",
  //       required: true,
  //     },
  //     {
  //       id: "pincode",
  //       labelName: "Pincode",
  //       placeholder: "Enter Pincode",
  //       required: true,
  //     },
  //   ],
  // },
  // {
  //   id: "",
  //   controlName: FormControlNames.EMAILFIELD,
  //   displayText: "Email",
  //   description: "Some Description about the field",
  //   labelName: "Label for Email",
  //   itemType: FormItemTypes.CONTROL,
  //   icon: "far fa-calendar",
  //   required: false,
  //   category: "text-elements",
  //   containerId: "",
  // },
  // {
  //   id: "",
  //   controlName: FormControlNames.PHONEFIELD,
  //   displayText: "Phone",
  //   description: "Some Description about the field",
  //   placeholder: "(+91 0000000000)",
  //   labelName: "Label for Phone",
  //   itemType: FormItemTypes.CONTROL,
  //   icon: "far fa-calendar",
  //   required: false,
  //   category: "text-elements",
  //   containerId: "",
  // },
  {
    id: "",
    controlName: FormControlNames.INPUTMULTILINE,
    displayText: "Notes",
    description: "Some Description about the field",
    placeholder: "Please write your notes here.",
    labelName: "Notes",
    rows: 4,
    itemType: FormItemTypes.CONTROL,
    icon: "far fa-file",
    required: false,
    category: "text-elements",
    containerId: "",
  },

  {
    id: "",
    controlName: FormControlNames.RADIOGROUP,
    displayText: "Radio",
    description: "Some Description about the field",
    labelName: "Label for Radio",
    itemType: FormItemTypes.CONTROL,
    icon: "far fa-dot-circle",
    required: false,
    items: [
      {
        id: generateID(),
        value: "Button__-1",
        label: "Button 1",
      },
      {
        id: generateID(),
        value: "Button__-2",
        label: "Button 2",
      },
    ],
    category: "other-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.TOGGLE,
    displayText: "Toggle",
    description: "Some Description about the field",
    labelName: "Label for Toggle",
    itemType: FormItemTypes.CONTROL,
    icon: "fas fa-toggle-on",
    required: false,
    category: "other-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.CHECKLIST,
    displayText: "Checklist",
    description: "Some Description about the field",
    labelName: "Label for Checklist",
    itemType: FormItemTypes.CONTROL,
    icon: "fas fa-tasks",
    required: false,
    items: [
      {
        id: generateID(),
        value: "Check__-1",
        label: "Check 1",
      },
      {
        id: generateID(),
        value: "Check__-2",
        label: "Check 2",
      },
    ],
    category: "other-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.SELECTDROPDOWN,
    displayText: "Dropdown",
    description: "Some Description about the field",
    labelName: "Label for Dropdown",
    itemType: FormItemTypes.CONTROL,
    icon: "far fa-caret-square-down",
    required: false,
    items: [
      {
        id: generateID(),
        value: "Option__-1",
        label: "Option 1",
      },
      {
        id: generateID(),
        value: "Option__-2",
        label: "Option 2",
      },
    ],
    category: "other-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.CHECKBOX,
    displayText: "Checkbox",
    description: "Some Description about the field",
    labelName: "Label for Checkbox",
    placeholder: "Place Holder Text",
    itemType: FormItemTypes.CONTROL,
    icon: "far fa-check-square",
    required: false,
    category: "other-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.DATEFIELD,
    displayText: "Date Picker",
    description: "Some Description about the field",
    labelName: "Label for Date",
    itemType: FormItemTypes.CONTROL,
    icon: "far fa-calendar",
    required: false,
    category: "date-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.TIMEFIELD,
    displayText: "Time",
    description: "Some Description about the field",
    labelName: "Label for Time",
    itemType: FormItemTypes.CONTROL,
    icon: "far fa-clock",
    required: false,
    category: "date-elements",
    containerId: "",
  },
  // {
  //   id: "",
  //   controlName: FormControlNames.SIGNATURE,
  //   displayText: "Signature",
  //   description: "Some Description about the field",
  //   labelName: "Label for Signature",
  //   itemType: FormItemTypes.CONTROL,
  //   icon: "fa fa-signature",
  //   required: false,
  //   category: "other-elements",
  //   containerId: "",
  // },
  {
    id: "",
    controlName: FormControlNames.FILEUPLOAD,
    displayText: "Signature",
    description: "Some Description about the field",
    labelName: "Label for Signature",
    itemType: FormItemTypes.CONTROL,
    icon: "fa fa-signature",
    required: false,
    category: "other-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.IMAGEUPLOAD,
    displayText: "Image",
    description: "Some Description about the field",
    labelName: "Label for Image Upload",
    itemType: FormItemTypes.CONTROL,
    icon: "far fa-image",
    required: false,
    category: "media-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.CAPTURECLICK,
    displayText: "Camera",
    description: "Some Description about the field",
    labelName: "Label for Camera Click",
    itemType: FormItemTypes.CONTROL,
    icon: "fas fa-camera",
    required: false,
    category: "media-elements",
    containerId: "",
  },
  {
    id: "",
    controlName: FormControlNames.SCANCODE,
    displayText: "Upload",
    description: "Some Description about the field",
    labelName: "Label for Attach Upload",
    itemType: FormItemTypes.CONTROL,
    icon: "far fa-image",
    required: false,
    category: "media-elements",
    containerId: "",
  },
];
